//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { faCode } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'ShareProductModal',
  components: {
    AddToAny: () => import('@motionelements/core/src/components/modules/common/AddToAny.vue'),
    LoaderSpin: () => import('@motionelements/core/src/components/ui/LoaderSpin.vue'),
  },
  data() {
    return {
      faCode,
    };
  },
  computed: {
    ...mapState({
      product: state => state.product.current,
      embedCode: state => state.product.current.embedCode,
    }),
    isLoaded() {
      return this.embedCode !== null;
    },
  },
  mounted() {
    this.$store.dispatch('product/getEmbedCode', {
      id: this.product.id,
    });
  },
};
